import { ErrorMessages } from "./_errorTypes";
import { errorMessages } from './errorMessages';
import { getStoredLanguage } from './languageStorage';

export function handleError(error: unknown): string {

    if (typeof error === 'string')
        return error;

    if (error instanceof Error)
        return error.message;

    if (error && typeof error === 'object' && 'message' in error) {
        const customError = error as { message: string };
        return customError.message;
    }

    return getErrorMessage('GENERAL_ERROR_MESSAGE');
}

function getErrorMessage(key: keyof ErrorMessages['en']): string {
    const lang = getSelectedLanguage() as keyof ErrorMessages;
    return errorMessages[lang][key] || errorMessages['en'][key] || 'An unknown error occurred';
}

function getSelectedLanguage(): string {
    return getStoredLanguage();
}
